import { useAuth } from "../contexts/AuthContext";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Link } from "react-router-dom";
import { Users, CreditCard, Tags, FolderKanban, FileSpreadsheet } from "lucide-react";
import WorkerDashboard from "./worker/WorkerDashboard";
import ExpenseList from "./expenses/ExpenseList";
import UnmatchedVendorsStrip from "./statements/UnmatchedVendorsStrip";

function PageHeader({ title, subtitle }) {
  return (
    <div className="mb-8">
      <h1 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-slate-500 sm:text-base">{subtitle}</p>}
    </div>
  );
}

function AdminDashboard() {
  const tiles = [
    { to: "/admin/users", label: "Users", desc: "Workers, accounting, admins", icon: Users, testId: "tile-users" },
    { to: "/admin/cards", label: "Cards", desc: "Credit, EFS & debit registry", icon: CreditCard, testId: "tile-cards" },
    { to: "/admin/categories", label: "Categories", desc: "Expense classification", icon: Tags, testId: "tile-categories" },
    { to: "/admin/departments", label: "Departments", desc: "Cost-center codes", icon: FolderKanban, testId: "tile-departments" },
    { to: "/expenses", label: "All Expenses", desc: "View company-wide expenses", icon: FileSpreadsheet, testId: "tile-all-expenses" },
  ];
  return (
    <div data-testid="admin-dashboard">
      <PageHeader title="Admin dashboard" subtitle="Manage the foundation and review all expenses." />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {tiles.map((t) => (
          <Link key={t.to} to={t.to} data-testid={t.testId} className="group">
            <Card className="h-full border-slate-200 transition-shadow hover:shadow-md">
              <CardHeader className="space-y-3 pb-2">
                <div className="flex h-9 w-9 items-center justify-center rounded-md bg-[#0F1E3D]/5 text-[#0F1E3D]">
                  <t.icon className="h-5 w-5" />
                </div>
                <CardTitle className="text-base font-semibold text-slate-900">{t.label}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-slate-500">{t.desc}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default function Landing() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin") return <AdminDashboard />;
  if (user.role === "accounting") {
    return (
      <div data-testid="accounting-dashboard">
        <UnmatchedVendorsStrip days={7} />
        <ExpenseList />
      </div>
    );
  }
  return <WorkerDashboard />;
}
